import type { HoldCleaningInformationFilter } from "../models/hold-cleaning.models";

export const HOLD_CLEANING_INFORMATION_OPTIONS: ReadonlyArray<{
  value: HoldCleaningInformationFilter;
  label: string;
  description: string;
}> = [
  {
    value: "PHOTOS",
    label: "Photos — current voyage",
    description: "A validated photo record on the current voyage, with or without a hold assignment.",
  },
  {
    value: "PHOTOS_HISTORY",
    label: "Photos — previous voyages",
    description:
      "Photos on one of the four previous voyages shown in vessel history. The list still shows the current voyage and requires cleaning data on it.",
  },
  {
    value: "CHEMICALS_EQUIPMENT",
    label: "Chemicals/equipment",
    description: "Inventory values from forms, extracted reports or manual entries on the current voyage.",
  },
  {
    value: "CLEANING_PROGRESS",
    label: "Cleaning Progress",
    description:
      "At least one of the 13 cleaning steps has a reported status. Unknown placeholders and percentage-only updates do not count.",
  },
  {
    value: "CREW_REPORT",
    label: "Crew report",
    description:
      "A current OpsLink Crew Report roster exists for the vessel. This does not guarantee the report is recent.",
  },
];
